import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { GridBaseComponent } from '../../shared/grid-base/grid-base.component';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { ClientService } from '../../services/client/client.service';
import { LinkedParkerDTO } from '../../models/models.swagger.generated';
import { FormBuilder } from '@angular/forms';
import { CommandClickEventArgs, GridModule } from '@syncfusion/ej2-angular-grids';
import { ModalService } from '../../shared/modal/modal.service';
import { ParkerAdministrationService } from '../../../domain/administration/parker-administration/parker-administraton.service';
import { SfCommandButtonType } from '../../models/syncfusion-data';
import { LinkedParkerFormType } from './linked-parker-form.type';

@Component({
    selector: 'app-linked-parker',
    templateUrl: './linked-parker.component.html',
    styleUrls: ['./linked-parker.component.scss'],
    imports: [GridModule, TranslateModule]
})
export class LinkedParkerComponent extends GridBaseComponent implements OnInit {

  @Input() linkedParkers: LinkedParkerDTO[];
  @Output() linkedParkersChange = new EventEmitter<LinkedParkerDTO[]>();


  constructor(translateService: TranslateService,
              clientService: ClientService,
              private fb: FormBuilder,
              private modalService: ModalService,
              private parkerAdministrationService: ParkerAdministrationService) {
    super(clientService, translateService, null);
  }

  ngOnInit(): void {
    this.gridCommands = [{
      type: 'None',
      title: this.translateService.instant('i18n.domain.parker-administration.unlink'),
      buttonOption: {
        cssClass: 'icon-btn',
        iconCss: 'icon-unlink e-icons'
      }
    }];
  }

  public commandClicked(args: CommandClickEventArgs): void {
    if (args.commandColumn.type === SfCommandButtonType.None) {
      const parker = args.rowData as LinkedParkerDTO;
      const index = this.linkedParkers.indexOf(parker);

      const dialog = this.modalService.showOkCancelDialog('i18n.domain.parker-administration.unlink', 'i18n.domain.parker-administration.unlink-question');
      dialog.onOkSubject.subscribe(() => {
        this.parkerAdministrationService.unlinkUserFromParker(parker.parkerId).subscribe(() => {
          this.linkedParkers.splice(index, 1);
          this.grid.refresh();
          this.linkedParkersChange.emit(this.linkedParkers);
        });
      });
      return;
    }
  }

  protected getEditDialogTitleParams(rowData: any) {
    {}
  }

  protected initializeEditForm(data: any): void {
    this.gridEditForm = this.fb.group<LinkedParkerFormType>({
      parkerId: this.fb.control(data.parkerId),
      firstName: this.fb.control(data.firstName),
      lastName: this.fb.control(data.lastName),
      company: this.fb.control(data.company),
    });
  }
}
